// extracted by mini-css-extract-plugin
module.exports = {"infoItem":"styles_infoItem__3ptDL"};